import styled from "styled-components";

export const EyeStyled = styled.div`
  position: absolute;
  top: 38px;
  right: 14px;
  cursor: pointer;

  .passwordIcon {
    width: 20px;
    height: 20px;
    display: block;
    opacity: 0.55;
    transition: opacity 0.15s ease;
  }

  &:hover .passwordIcon {
    opacity: 1;
  }
`;

export const SiginWrapper = styled.div`
  min-height: 100vh;
  overflow: hidden;

  /* ── Two-column layout ── */
  .login-layout {
    display: flex;
    min-height: 100vh;
  }

  /* ── Left panel ── */
  .login-left {
    position: relative;
    flex: 0 0 50%;
    max-width: 50%;
    display: block;
  }

  .loginImg {
    width: 100%;
    height: 100vh;
    object-fit: cover;
    display: block;
  }

  .Login-description {
    position: absolute;
    top: 18%;
    left: 0;
    right: 0;
    padding: 0 48px 0 56px;
  }

  .lungsImg {
    width: 72px;
    height: 72px;
  }

  .login-heading {
    font-size: 48px;
    font-weight: 700;
    line-height: 64px;
    color: #ffffff;
    margin-top: 20px;
    margin-bottom: 16px;
  }

  .login-desc {
    font-size: 17px;
    font-weight: 400;
    line-height: 27px;
    color: #ffffffcc;
    margin-bottom: 0;
  }

  .copyRightDiv {
    display: flex;
    align-items: center;
    margin-top: 56px;
  }

  .copyrightImg {
    width: 18px;
    height: 18px;
    margin-right: 10px;
  }

  .copyright {
    font-size: 14px;
    font-weight: 400;
    color: #ffffffb2;
    margin: 0;
  }

  /* ── Right panel ── */
  .login-right {
    flex: 0 0 50%;
    max-width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    padding: 48px 24px;
  }

  /* ── Form box ── */
  .login-form-box {
    width: 100%;
    max-width: 400px;
  }

  .qbaceLogo {
    width: 148px;
    height: auto;
    display: block;
    margin-bottom: 36px;
  }

  .login-form-header {
    margin-bottom: 28px;
  }

  .loginHeading {
    font-size: 24px;
    font-weight: 700;
    color: #151617;
    margin-bottom: 6px;
  }

  .loginSubtitle {
    font-size: 14px;
    font-weight: 400;
    color: #6b7280;
    margin: 0;
  }

  /* ── Field group ── */
  .field-group {
    margin-bottom: 4px;
  }

  .label-text {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #151617;
    margin-bottom: 6px;
  }

  .mandatory {
    color: #ef4444;
    margin-left: 2px;
  }

  .field-error {
    font-size: 12px;
    color: #ef4444;
    margin: 4px 0 8px;
    min-height: 18px;
    visibility: hidden;

    &.visible {
      visibility: visible;
    }
  }

  /* ── Login button ── */
  .login-btn-wrap {
    margin-top: 8px;
  }

  /* ── 1024–1200px ── */
  @media (min-width: 1024px) and (max-width: 1200px) {
    .Login-description {
      padding: 0 32px 0 40px;
      top: 12%;
    }

    .login-heading {
      font-size: 38px;
      line-height: 52px;
    }

    .login-desc {
      font-size: 15px;
    }

    .copyRightDiv {
      margin-top: 40px;
    }
  }

  /* ── Tablet: 768–1023px ── */
  @media (min-width: 768px) and (max-width: 1023px) {
    .Login-description {
      padding: 0 24px 0 28px;
      top: 10%;
    }

    .login-heading {
      font-size: 30px;
      line-height: 42px;
    }

    .login-desc {
      font-size: 14px;
      line-height: 22px;
    }

    .copyRightDiv {
      margin-top: 32px;
    }

    .login-form-box {
      max-width: 360px;
    }
  }

  /* ── Mobile ≤ 767px: hide illustration ── */
  @media (max-width: 767px) {
    .login-left {
      display: none;
    }

    .login-right {
      flex: 0 0 100%;
      max-width: 100%;
      padding: 48px 24px 40px;
      align-items: flex-start;
      padding-top: 64px;
    }

    .login-form-box {
      max-width: 100%;
      width: 100%;
    }

    .loginHeading {
      font-size: 20px;
    }

    .qbaceLogo {
      width: 130px;
      margin-bottom: 28px;
    }

    .login-form-header {
      margin-bottom: 24px;
    }
  }

  /* ── Very small ≤ 400px ── */
  @media (max-width: 400px) {
    .login-right {
      padding: 48px 20px 32px;
    }
  }
`;
